import "./App.css";
import Header from "./components/Header/Header.js";
import MainComponent from "./components/MainComponent/mainComponent";
import Footer from "./components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <MainComponent />
      <Footer />
    </div>
  );
}

export default App;
